import { FighterInfo } from '../models/fighterInfo.model';
import { UserSeasonFighter } from '../models/userSeason.model';

// Helper function to format fighters for the backend
export const formatFightersForBackend = (
  fighters: FighterInfo[],
): UserSeasonFighter[] => {
  return fighters.map((fighter) => ({
    position: fighter.CardId,
    fighterId: fighter.FighterId,
    fightId: fighter.FightId,
    points: typeof fighter.Points === 'number' ? fighter.Points : 0,
  }));
};
